(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/rich-text-state.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/rich-text-state.js');

'use strict';

const EMPTY_STATE_JSON = JSON.stringify({
  root: {
    children: [{
      children: [],
      direction: null,
      format: '',
      indent: 0,
      type: 'paragraph',
      version: 1
    }],
    direction: null,
    format: '',
    indent: 0,
    type: 'root',
    version: 1
  }
});
function extractPlainText(node) {
  if (!node) {
    return '';
  }
  if (node.type === 'text') {
    return node.text || '';
  }
  if (node.type === 'linebreak') {
    return '\n';
  }
  if (!Array.isArray(node.children)) {
    return '';
  }
  const childTexts = node.children.map(extractPlainText);

  if (node.type === 'root' || node.type === 'list') {
    return childTexts.join('\n');
  }
  return childTexts.join('');
}
function RichTextState(lexicalJsonString) {
  this._json = lexicalJsonString || EMPTY_STATE_JSON;
}
RichTextState.createEmpty = function () {
  return new RichTextState(EMPTY_STATE_JSON);
};
RichTextState.prototype.getLexicalJson = function () {
  return this._json;
};
RichTextState.prototype.getPlainText = function () {
  try {
    const state = JSON.parse(this._json);
    return extractPlainText(state.root);
  } catch (e) {
    return '';
  }
};
RichTextState.prototype.isEmpty = function () {
  return this.getPlainText().trim().length === 0;
};
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.RichTextState', RichTextState);

 })(window);